import React from 'react';
import cn from 'classnames';
import style from './testimonials.mod.scss';
import Container from '../layout/container/container';
import Heading from '../heading/heading';

const Testimonials = ({ items }) => {
  const classes = cn(style.testimonials);

  return (
    <Container gutters size="lg">
      <div className={classes}>
        {items.map((item, index) => (
          <>
            <div className={style.testimonials__quote}> 
              <Heading tag={2} size={'md'} text={item.quote} />
            </div>
            <div className={style.testimonials__name}>{item.name}</div>
            <div className={style.testimonials__company}>{item.company}</div>
          </>
        ))}
      </div>
    </Container>
  );
};

export default Testimonials;
